// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for Amazon Location Service Places (GEO-PLACES)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonlocationserviceplaces.html
 *
 * 2025-02-24T21:48:39.578Z
 */
export enum AwsGeoPlacesActions {
  /**
   * Grants permission to autocomplete text input with potential places and addresse
   * s as the user types
   *
   * See https://docs.aws.amazon.com/location/latest/APIReference/API_geoplaces_Autocomplete.html
   */
  Autocomplete = 'geo-places:Autocomplete',
  /**
   * Grants permission to geocode a textual address or place into geographic coordin
   * ates
   *
   * See https://docs.aws.amazon.com/location/latest/APIReference/API_geoplaces_Geocode.html
   */
  Geocode = 'geo-places:Geocode',
  /**
   * Grants permission to query a place by it's unqiue place ID
   *
   * See https://docs.aws.amazon.com/location/latest/APIReference/API_geoplaces_GetPlace.html
   */
  GetPlace = 'geo-places:GetPlace',
  /**
   * Grants permission to convert geographic coordinates into a human-readable addre
   * ss or place
   *
   * See https://docs.aws.amazon.com/location/latest/APIReference/API_geoplaces_ReverseGeocode.html
   */
  ReverseGeocode = 'geo-places:ReverseGeocode',
  /**
   * Grants permission to retrieve places near a position which match to a set of us
   * er defined restrictions such as category or food type offered by the place
   *
   * See https://docs.aws.amazon.com/location/latest/APIReference/API_geoplaces_SearchNearby.html
   */
  SearchNearby = 'geo-places:SearchNearby',
  /**
   * Grants permission to query for places using a single free-form text input
   *
   * See https://docs.aws.amazon.com/location/latest/APIReference/API_geoplaces_SearchText.html
   */
  SearchText = 'geo-places:SearchText',
  /**
   * Grants permission to suggest potential places based on the user's input
   *
   * See https://docs.aws.amazon.com/location/latest/APIReference/API_geoplaces_Suggest.html
   */
  Suggest = 'geo-places:Suggest',
}
